export const environment = {
  production: true,
  config: {
    endpoints: {
      api: {
        protocol: "http",
        domain: "www.performancetraininglab.local",
        port: 80,
        contextPath: "api"
      },
      authApi: {
        protocol: "http",
        domain: "www.performancetraininglab.local",
        port: 80,
        contextPath: "auth/api"
      }
    },
    otp:{
      length:6
    },
    federatedLogin : false,
    requiredAuthorities: ["APP"],
    mockUserProfile : false,
    profileRefresh : 10000,
    logToConsole: true,
    enabledLocales: ["it-it"],
    autodetectLocale: false,
    chatRefreshIntervalInSec: 10,
    videoEnabled: true,
    videoUrl:"https://imaie.s3-eu-west-1.amazonaws.com/Nuovoimaie_Online_100521.mp4",//"https://content.jwplatform.com/manifests/yp34SRmf.m3u8",
    domain: "www.siae.local",
    cookiesConsentRequired: false,
    cookieConsentExpirationInDay:365,
    sessionKeepAliveIntervalInSec:60,
    attendanceMarkingEnabled:true,
    passwordSettingExpected: false,
    signUpExpected: true,
    emailAsUsername: false
  },
  mockUserProfile : {
    "authorities": ["IAM__USER_PROFILES__READ",
                    "IAM__USER_PROFILES__EDIT",
                    "IAM__USER_PROFILES__DELETE",
                    "IAM__USER_ACCOUNT_GROUPS__READ",
                    "IAM__USER_ACCOUNT_GROUPS__EDIT",
                    "IAM__USER_ACCOUNT_GROUPS__DELETE",
                    "IAM__ROLES__READ",
                    "IAM__ROLES__EDIT",
                    "IAM__ROLES__DELETE",
                    "MESSAGES__SEND",
                    "ROLE_SUPER_ADMIN"],
    "userId": "2",
    "username": "mario.rossi",
    "enabled": true,
    "nickname": null,
    "name": "Mario Rossi",
    "email": "lucaquarello@gmail.com",
    "emailVerified": true,
    "phoneNumber": "+393917148446",
    "phoneNumberVerified": true
  }
}
